/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function ($, FUNCTIONS) {
	let lang = location.pathname.split("/")[1];
	if (location.pathname.split("/")[1] === "global") {
		lang = "glo";
	}
	const a = "is-active";
	const v = "is-visible";

	console.log(a);
	console.log(v);

	const slider = () => {
		if ($(".biz-note-list").length) {
			$(".biz-note-list").slick({
				autoplay: true,
				dots: false,
				infinite: true,
				speed: 500,
				cssEase: "linear",
				arrows: true,
				prevArrow:
					'<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow:
					'<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
			});
		}
		if ($(".biz-products-detail-products-slide").length) {
			if ($(".biz-products-detail-products-slide ._item").length > 1) {
				$(".biz-products-detail-products-slide").slick({
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: false,
					infinite: true,
					draggable: false,
				});
			}
			$(".biz-products-detail-products-slide").css("opacity", "1");
		}
	};
	const bizSearch = () => {
		if ($(".js-biz-products-serchBlock").length) {
			$(".js-biz-products-serchBlock-btnArea").removeClass('di_none');
			var $switch = $(".js-biz-products-toggle");
			$switch.on("click", function () {
				$(this).toggleClass(a);
				$(this).parents(".js-biz-products-serchBlock").find(".js-biz-products-toggleBlock").stop().slideToggle(400);
			});
			if($(".js-biz-products-serchBlock-select").val()) {
				$(".js-biz-products-serchBlock-btnArea").removeClass('di_none');
				$(".js-biz-products-toggle").addClass(a);
				$(".js-biz-products-serchBlock").find(".js-biz-products-toggleBlock").stop().slideDown(400);
				$(".js-biz-products-serchBlock-select-item").each(function (idx, elem) {
					if ($(elem).data("select") == $(".js-biz-products-serchBlock-select").val()) {
						$(elem).removeClass("di_none");
					}
				});
			}
		}
		if ($(".js-biz-filter-clear").length) {
			$(".js-biz-filter-clear").on("click", function () {
				$("select").val("");
				$('input[type="text"]').val("");
				$("input").prop("checked", false);
				if ($(".js-biz-products-serchBlock-select-item").length) {
					$(".js-biz-products-serchBlock-select-item").addClass("di_none");
				}
				// if ($(".js-biz-products-serchBlock-btnArea").length) {
				// 	$(".js-biz-products-serchBlock-btnArea").addClass("di_none");
				// }
			});
		}
		$(".js-biz-download-select").change(function () {
			$("input").prop("checked", false);
		});
		$(".js-biz-products-serchBlock-select").change(function () {
			$(".js-biz-products-serchBlock-btnArea").removeClass('di_none');
			$("input").prop("checked", false);
			$(".js-biz-products-serchBlock-select-item").addClass("di_none");
			$(".js-biz-products-serchBlock-select-item").each(function (idx, elem) {
				if (
					$(elem).data("select") ==
					$(".js-biz-products-serchBlock-select").val()
				) {
					$(elem).removeClass("di_none");
				}
			});
		});
		$(".js-biz-products-serch-download").change(function () {
			const valueSelected = this.value;
			const link = document.createElement("a");
			link.target = "_blank";
			link.download = valueSelected.split("/").at(-1);
			link.href = valueSelected;
			link.click();
		});
		if ($(".js-biz-products-serch-total").length) {
			let num = 0;
			for (let i = 0; i < $(".js-biz-products-serch-total-num").length; i++) {
				num += Number($(".js-biz-products-serch-total-num").eq(i).text());
			}
			$(".js-biz-products-serch-total").text(num);
		}
	};
	const bizDownload = () => {
		if ($(".js-biz-download-head").length) {
			let head = "";
			for (let i = 0; i < $(".js-biz-download-head").length; i++) {
				if (
					!(head === $(".js-biz-download-head").eq(i).find("._main").text())
				) {
					head = $(".js-biz-download-head").eq(i).find("._main").text();
				} else {
					$(".js-biz-download-head").eq(i).addClass("di_none");
				}
			}
		}
	};
	const moreItem = () => {
		if ($(".js-biz-moreItem_20_5").length) {
			for (let i = 0; i < $(".js-biz-moreItem_20_5 > li").length; i++) {
				if (i < 20) {
					$(".js-biz-moreItem_20_5 > li").eq(i).removeClass("di_none");
				}
			}
			if ($(".js-biz-moreItem_20_5 > li").length < 21) {
				$(".js-biz-moreItem_20_5-button").addClass("di_none");
			}
			$(".js-biz-moreItem_20_5-button").on("click", function () {
				for (
					let l = 0;
					l < $(".js-biz-moreItem_20_5 > li.di_none").length;
					l++
				) {
					if (l < 5) {
						$(".js-biz-moreItem_20_5 > li.di_none").eq(l).addClass("is-check");
					}
				}
				$(".js-biz-moreItem_20_5 > li.is-check").removeClass("di_none");
				$(".js-biz-moreItem_20_5 > li.is-check").removeClass("is-check");
				if (!$(".js-biz-moreItem_20_5 > li.di_none").length) {
					$(".js-biz-moreItem_20_5-button").addClass("di_none");
				}
			});
		}
	};
	const bizProductsCategory1 = () => {
		if ($(".js-biz-products-category1").length) {
			for (let i = 0; i < $(".js-biz-products-category1").length; i++) {
				const getJSONProductsCategory1 = (_id) => {
					return $.getJSON(`/ajax/${lang}/biz/m_category/${_id}.json`);
				};
				getJSONProductsCategory1(
					$(".js-biz-products-category1").eq(i).find(".rt_cf_pc_code").text()
				).done((data) => {
					// console.log(data.rt_bn_m_category_info,'data');
					if (data.rt_bn_m_category_info.length) {
						data.rt_bn_m_category_info.forEach((item, index) => {
							console.log(item, "item");
							let HTML = "";
							let lead1 = "";
							let lead2 = "";
							// console.log(item,'item');
							if (item.cf_pc_explanation1_ja) {
								lead1 =
									'<p class="mod-spacer-24_16">' +
									item.cf_pc_explanation1_ja +
									"</p>";
							}
							if (item.cf_pc_explanation2_ja) {
								lead2 =
									'<p class="mod-spacer-24_16">' +
									item.cf_pc_explanation2_ja +
									"</p>";
							}
							let headtitle, lineup, endproducts;
							if (lang === "jp") {
								headtitle = item.cf_pc_name_ja;
								lineup = "<span>製品ラインアップ</span>";
								endproducts = "<span>販売終了製品</span>";
							} else {
								headtitle = item.cf_pc_name_en;
								lineup = "<span>Products Lineup</span>";
								endproducts = "<span>End-of-Sale Products</span>";
							}
							HTML =
								'<div class="pure-u-1-2 pure-u-md-1-1 space-u-32-child space-md-48-child">' +
								// '<a href="/' +location.pathname.split("/")[1] +"/biz/products/" +item.cf_pc_group_code +"/" +item.cf_pc_parent_code +"/#" +item.cf_pc_code +'" rel="scroll" class="di_iblock mod-textLink01">' +
								'<h3 class="biz-head02" style="text-decoration: none;"><span>' +
								headtitle +
								"</span></h3>" +
								// "</a>" +
								lead1 +
								lead2 +
								'<div class="mod-spacer-32_24"><ul class="biz-products-buttonWrap">' +
								'<li class="_button">' +
								'<a href="/' +
								location.pathname.split("/")[1] +
								"/biz/products/" +
								item.cf_pc_group_code +
								"/" +
								item.cf_pc_parent_code +
								"/#" +
								item.cf_pc_code +
								'" rel="scroll" class="mod-button _border _230">' +
								lineup +
								"</a>" +
								"</li>" +
								// '<li><a href="/' +location.pathname.split("/")[1] +'/biz/discon/' +item.cf_pc_group_code +'.html" class="mod-textLink01">' +endproducts +'<svg><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>' +'</a></li>' +
								"</ul></div>" +
								"</div>";
							$(".js-biz-products-category1").eq(i).append(HTML);
						});
					}
				});
			}
		}
	};
	const bizProductsCategory2 = () => {
		// html出力---------------------
		const addHTML = (_elem, _area, _type) => {
			console.log(_elem, "json");
			let HTML = "";
			// newだし分け
			let newIcon = "";
			if (_elem.cf_p_new_product) {
				if (_elem.cf_p_new_product == "1") {
					newIcon = '<span class="biz-products-label _new">NEW</span>';
				}
			}
			// 生産終了だし分け
			let conditionIcon = "";
			if (_elem.cf_p_condition) {
				if (_elem.cf_p_condition == "1") {
					if (lang === "jp") {
						conditionIcon =
							'<span class="biz-products-label _endProduction">生産終了</span>';
					} else {
						conditionIcon =
							'<span class="biz-products-label _endProduction">Discontinued</span>';
					}
				} else if (_elem.cf_p_condition == "2") {
					if (lang === "jp") {
						conditionIcon =
							'<span class="biz-products-label _endSale">販売終了</span>';
					} else {
						conditionIcon =
							'<span class="biz-products-label _endSale">End-of-Sale</span>';
					}
				}
			}
			// 備考出力
			let remarks = "";
			if (_elem.cf_p_list_remarks) {
				remarks = _elem.cf_p_list_remarks;
			}
			let remarksModel = '';
			if(remarks) {
				if (_type === "other") {
					remarksModel = '<p class="fs_12 mt8">'+remarks+'</p>';
				} else if (_type === "ipcctv") {
					remarksModel = '<p class="fs_12 mt8">'+remarks+'</p>';
				} else if (_type === "fa") {
					remarksModel = '<p class="fs_12 mt8">'+remarks+'</p>';
				}
			}
			// tag ----------
			// td項目
			let ipcctvImagerSize = "";
			let ipcctvFocalLength = "";
			let ipcctvShibori = "";
			let ipcctvIrisType = "";
			let faImagerSize = "";
			let faFocalLength = "";
			let faShibori = "";
			let faIrisType = "";
			let ccmFocalLength = "";
			let ccmSensor = "";
			let ccmFNo = "";
			let ccmHorizonal = "";
			// let remarks = "";
			let ccmOutputPixels = "";
			let ccmHorizonal_wide = "";
			// function_icon
			let functionIcon1 = "";
			let functionIcon2 = "";
			let functionIcon3 = "";
			let functionIcon4 = "";
			if(_elem.cf_p_tags) {
				_elem.cf_p_tags.forEach((tag) => {
					if (tag.cf_pt_group_code == "ipcctv-imager-size") {
						if (lang === "jp") {
							if(!ipcctvImagerSize) {
								ipcctvImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_ja+'</span>';
							} else {
								ipcctvImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_ja+'</span>';
							}
						} else {
							if(!ipcctvImagerSize) {
								ipcctvImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_en+'</span>';
							} else {
								ipcctvImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_en+'</span>';
							}
						}
					}
					if (tag.cf_pt_group_code == "ipcctv-focal-length") {
						if (lang === "jp") {
							ipcctvFocalLength = tag.cf_pt_name_d_ja;
						} else {
							ipcctvFocalLength = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ipcctv-aperture-range") {
						if (lang === "jp") {
							ipcctvShibori = tag.cf_pt_name_d_ja;
						} else {
							ipcctvShibori = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ipcctv-iris") {
						if (lang === "jp") {
							ipcctvIrisType = tag.cf_pt_name_d_ja;
						} else {
							ipcctvIrisType = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "fa-imager-size") {
						if (lang === "jp") {
							if(!faImagerSize) {
								faImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_ja+'</span>';
							} else {
								faImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_ja+'</span>';
							}
						} else {
							if(!faImagerSize) {
								faImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_en+'</span>';
							} else {
								faImagerSize += '<span class="" style="order:'+tag.cf_pt_order+';">'+tag.cf_pt_name_d_en+'</span>';
							}
						}
					}
					if (tag.cf_pt_group_code == "fa-focal-length") {
						if (lang === "jp") {
							faFocalLength = tag.cf_pt_name_d_ja;
						} else {
							faFocalLength = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "fa-aperture-range") {
						if (lang === "jp") {
							faShibori = tag.cf_pt_name_d_ja;
						} else {
							faShibori = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "fa-iris") {
						if (lang === "jp") {
							faIrisType = tag.cf_pt_name_d_ja;
						} else {
							faIrisType = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ccm-sensor") {
						if (lang === "jp") {
							ccmSensor = tag.cf_pt_name_d_ja;
						} else {
							ccmSensor = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ccm-focal-length") {
						if (lang === "jp") {
							ccmFocalLength = tag.cf_pt_name_d_ja;
						} else {
							ccmFocalLength = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ccm-f-no") {
						if (lang === "jp") {
							ccmFNo = tag.cf_pt_name_d_ja;
						} else {
							ccmFNo = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ccm-horizonal-field-of-view") {
						if (lang === "jp") {
							ccmHorizonal = tag.cf_pt_name_d_ja;
						} else {
							ccmHorizonal = tag.cf_pt_name_d_en;
						}
					}
					// if (tag.cf_pt_name_d_ja == "備考") {
					// 	if (lang === "jp") {
					// 		remarks = tag.cf_pt_explanation_ja;
					// 	} else {
					// 		remarks = tag.cf_pt_explanation_en;
					// 	}
					// }
					if (tag.cf_pt_group_code == "ccm-output-pixels") {
						if (lang === "jp") {
							ccmOutputPixels = tag.cf_pt_name_d_ja;
						} else {
							ccmOutputPixels = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "ccm-horizonal-field-of-view_wide-tele") {
						if (lang === "jp") {
							ccmHorizonal_wide = tag.cf_pt_name_d_ja;
						} else {
							ccmHorizonal_wide = tag.cf_pt_name_d_en;
						}
					}
					if (tag.cf_pt_group_code == "function_icon") {
						if (lang === "jp") {
							if (tag.cf_pt_name_d_ja == "メガピクセル対応") {
								functionIcon1 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _blue">メガピクセル対応</p></li>';
							}
							if (tag.cf_pt_name_d_ja == "近赤外対応") {
								functionIcon2 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _red">近赤外対応</p></li>';
							}
							if (tag.cf_pt_name_d_ja == "Visible～SWIR") {
								functionIcon2 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _pink">Visible～SWIR</p></li>';
							}
							if (tag.cf_pt_name_d_ja == "非球面レンズ") {
								functionIcon3 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label">非球面レンズ</p></li>';
							}
							if (tag.cf_pt_name_d_ja == "有害物質規制対応") {
								functionIcon4 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label">有害物質規制対応</p></li>';
							}
						} else {
							if (tag.cf_pt_name_d_en == "Mega-Pixel") {
								functionIcon3 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _blue">Mega-Pixel</p></li>';
							}
							if (tag.cf_pt_name_d_en == "Infrared") {
								functionIcon4 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _red">Infrared</p></li>';
							}
							if (tag.cf_pt_name_d_en == "Visible - SWIR") {
								functionIcon4 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label _pink">Visible - SWIR</p></li>';
							}
							if (tag.cf_pt_name_d_en == "Aspherical Lens") {
								functionIcon1 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label">Aspherical Lens</p></li>';
							}
							if (tag.cf_pt_name_d_en == "RoHs Compatible") {
								functionIcon2 =
									'<li data-order="'+tag.cf_pt_order+'" class="_item"><p class="biz-products-label">RoHs Compatible</p></li>';
							}
						}
					}
				});
			}
			let tdBlock = "";
			if (_type === "lwir") {
				tdBlock =
					"<td>" +
					ccmSensor +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ccm-sensor の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ccmFocalLength +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ccm-focal-length の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ccmFNo +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code がccm-f-noの cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ccmHorizonal +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ccm-horizonal-field-of-view の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					remarks +
					"<!-- tagのうち、ccf_p_tags.cf_pt_name_d_ja が 『備考』のタグの cf_p_tags.cf_pt_explanation_ja を出力 --></td>";
			} else if (_type === "compact-camera-module") {
				tdBlock =
					"<td>" +
					ccmOutputPixels +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ccm-output-pixels の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ccmHorizonal_wide +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ccm-horizonal-field-of-view_wide-tele の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					remarks +
					"<!-- tagのうち、ccf_p_tags.cf_pt_name_d_ja が 『備考』のタグの cf_p_tags.cf_pt_explanation_ja を出力 --></td>";
			} else if (_type === "other") {
				tdBlock =
					"<td>" +
					ipcctvImagerSize +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-imager-size の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ipcctvFocalLength +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-focal-length の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ipcctvShibori +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-aperture-range の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ipcctvIrisType +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-iris の cf_p_tags.cf_pt_name_d_ja を出力 --></td>";
			} else if (_type === "ipcctv") {
				tdBlock =
					'<td><p class="biz-products-order">' +
					ipcctvImagerSize +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-imager-size の cf_p_tags.cf_pt_name_d_ja を出力 --></p></td>" +
					"<td>" +
					ipcctvFocalLength +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-focal-length の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ipcctvShibori +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-aperture-range の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					ipcctvIrisType +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が ipcctv-iris の cf_p_tags.cf_pt_name_d_ja を出力 --></td>";
			} else if (_type === "fa") {
				tdBlock =
					'<td><p class="biz-products-order">' +
					faImagerSize +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が fa-imager-size の cf_p_tags.cf_pt_name_d_ja を出力 --></p></td>" +
					"<td>" +
					faFocalLength +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が fa-focal-length の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					faShibori +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が fa-aperture-range の cf_p_tags.cf_pt_name_d_ja を出力 --></td>" +
					"<td>" +
					faIrisType +
					"<!-- tagのうち、cf_p_tags.cf_pt_group_code が fa-iris の cf_p_tags.cf_pt_name_d_ja を出力 --></td>";
			}
			// ダウンロード ----------
			let catalog = "";
			let leaflet = "";
			let dimensions = "";
			let specSheet = "";
			let whitePaper = "";
			let manual = "";
			let dFa = "";
			let downloadPull = "";
			let downloadArea = "";
			if (_elem.cf_p_catalog) {
				if (_elem.cf_p_catalog.cf_pct_status == "1") {
					if (lang === "jp") {
						catalog =
							'<option value="' +
							_elem.cf_p_catalog.cf_pct_attachment_file_url +
							'">カタログ</option>';
					} else {
						catalog =
							'<option value="' +
							_elem.cf_p_catalog.cf_pct_attachment_file_url +
							'">Catalog</option>';
					}
				}
			}
			if (_elem.cf_p_leaflet) {
				if (_elem.cf_p_leaflet.cf_ple_status == "1") {
					if (lang === "jp") {
						leaflet =
							'<option value="' +
							_elem.cf_p_leaflet.cf_ple_attachment_file_url +
							'">リーフレット</option>';
					} else {
						leaflet =
							'<option value="' +
							_elem.cf_p_leaflet.cf_ple_attachment_file_url +
							'">Leaflet</option>';
					}
				}
			}
			if (_elem.cf_p_dimensions) {
				if (_elem.cf_p_dimensions.cf_pdm_status == "1") {
					if (lang === "jp") {
						dimensions =
							'<option value="' +
							_elem.cf_p_dimensions.cf_pdm_attachment_file_url +
							'">製品外観図(3D CAD)</option>';
					} else {
						dimensions =
							'<option value="' +
							_elem.cf_p_dimensions.cf_pdm_attachment_file_url +
							'">External Dimensions(3D CAD)</option>';
					}
				}
			}
			if (_elem.cf_p_spec_sheet) {
				if (_elem.cf_p_spec_sheet.cf_pss_status == "1") {
					if (lang === "jp") {
						specSheet =
							'<option value="' +
							_elem.cf_p_spec_sheet.cf_pss_attachment_file_url +
							'">スペックシート</option>';
					} else {
						specSheet =
							'<option value="' +
							_elem.cf_p_spec_sheet.cf_pss_attachment_file_url +
							'">Specifications</option>';
					}
				}
			}
			if (_elem.cf_p_white_paper) {
				if (_elem.cf_p_white_paper.cf_pwp_status == "1") {
					if (lang === "jp") {
						whitePaper =
							'<option value="' +
							_elem.cf_p_white_paper.cf_pwp_attachment_file_url +
							'">ホワイトペーパー</option>';
					} else {
						whitePaper =
							'<option value="' +
							_elem.cf_p_white_paper.cf_pwp_attachment_file_url +
							'">White Paper</option>';
					}
				}
			}
			if (_elem.cf_p_manual) {
				if (_elem.cf_p_manual.cf_pma_status == "1") {
					if (lang === "jp") {
						manual =
							'<option value="' +
							_elem.cf_p_manual.cf_pma_attachment_file_url +
							'">取扱説明書</option>';
					} else {
						manual =
							'<option value="' +
							_elem.cf_p_manual.cf_pma_attachment_file_url +
							'">Owner’s Manual</option>';
					}
				}
			}
			if (_elem.cf_p_fa) {
				if (_elem.cf_p_fa.cf_fa_status == "1") {
					if (lang === "jp") {
						dFa =
							'<option value="' +
							_elem.cf_p_fa.cf_fa_attachment_file_url +
							'">撮影範囲資料</option>';
					} else {
						dFa =
							'<option value="' +
							_elem.cf_p_fa.cf_fa_attachment_file_url +
							'">Imaging Range Materials</option>';
					}
				}
			}
			downloadPull =
				catalog + leaflet + dimensions + specSheet + whitePaper + manual + dFa;
			// console.log(downloadPull,_elem,'download');
			if (downloadPull) {
				if (lang === "jp") {
					downloadArea +=
						'<div class="mod-select _min mod-spacer-16_8"><label for=""><select name="" class="js-biz-category-download-pull" id="' +
						_elem._key +
						'"><option value="" disabled selected>ダウンロード</option>';
				} else {
					downloadArea +=
						'<div class="mod-select _min mod-spacer-16_8"><label for=""><select name="" class="js-biz-category-download-pull" id="' +
						_elem._key +
						'"><option value="" disabled selected>Download</option>';
				}
				downloadArea += downloadPull;
				downloadArea +=
					'</select><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_bottom" /></svg></label></div>';
			}
			HTML +=
				"<tr>" +
				"<td>" +
				'<a href="/' +location.pathname.split("/")[1] +"/biz/products/" +_elem.cf_pb_category.cf_pc_group_code +"/" +_elem._key +'.html" class="di_block opacity">' +
				'<ul class="pure-g pure-g-align_center space-u-8">' +
				'<li class="pure-u-1-4 pure-u-md-1-3 space-u-8-child">' +
				'<figure class=""><img src="/jp/biz/pb_file/file/' +_elem.cf_p_product_img +'" alt="' +_elem.cf_p_title +'" class="height-auto width-u-100" loading="lazy" width="600" height="600"></figure></li>' +
				'<li class="pure-u-3-4 pure-u-md-2-3 space-u-8-child">' +
				'<p class="fw_medium biz-products-labelWrap">' +
				'<span class="_item di_block">' +
				_elem.cf_p_title +
				"</span>" +
				'<span class="_item di_block">' +
				newIcon +
				"</span>" +
				'<span class="_item di_block">' +
				conditionIcon +
				"</span>" +
				"</p>" +
				"</li>" +
				"</ul>"+
				remarksModel +
				"</a></td>" +
				tdBlock +
				"<td>" +
				'<ul class="biz-products-labelWrap">' +
				functionIcon1 +
				functionIcon2 +
				functionIcon3 +
				functionIcon4 +
				"</ul>" +
				downloadArea +
				"</td>" +
				"</tr>";
			_area.append(HTML);

			$(".js-biz-category-download-pull#" + _elem._key).on(
				"change",
				function (e) {
					const valueSelected = this.value;
					const link = document.createElement("a");
					link.target = "_blank";
					link.download = valueSelected.split("/").at(-1);
					link.href = valueSelected;
					link.click();
					this.selectedIndex = 0;
				}
			);
		};

		const bizProductsCategoryIpcctvOthersAndFa = () => {
			if ($(".js-biz-category-ipcctv_others_and_fa").length) {
				let count = 0;
				const getJSONProductsCategoryIpcctv = (_category) => {
					return $.getJSON(
						`/ajax/${lang}/biz/products/detail/m/${_category}.json`
					);
				};
				for (
					let i = 0;
					i < $(".js-biz-category-ipcctv_others_and_fa").length;
					i++
				) {
					const _category = $(".js-biz-category-ipcctv_others_and_fa")
						.eq(i)
						.find(".rt_cf_pc_code")
						.text();
					const _groupcategory = $(".js-biz-category-ipcctv_others_and_fa")
						.eq(i)
						.find(".rt_cf_pc_group_code")
						.text();
					getJSONProductsCategoryIpcctv(_category).done((data) => {
						const area = $(".js-biz-category-ipcctv_others_and_fa")
							.eq(i)
							.find(".mod-tblWrap table tbody");
						if (data.rt_bn_products_list.length > 0) {
							data.rt_bn_products_list.forEach((elem) => {
								addHTML(elem, area, _groupcategory);
							});
							const sortToggle = function (data, tagCode, type) {
								data.rt_bn_products_list.sort(function (a, b) {
									const getValue = function (item) {
										const found = item.cf_p_tags.find(
											(tag) => tag.cf_pt_group_code == tagCode
										);
										return found
											? found.cf_pt_order
											: "";
									};
									const aValue = getValue(a);
									const bValue = getValue(b);
									if (aValue < bValue) return type == "up" ? -1 : 1;
									if (aValue > bValue) return type == "up" ? 1 : -1;
									return 0;
								});
								area.empty();
								data.rt_bn_products_list.forEach((elem) => {
									addHTML(elem, area, _groupcategory);
								});
							};
							$(".js-biz-products-tbl-sort-ipcctv-imager-size ._up").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-imager-size", "up");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-imager-size ._down").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-imager-size", "down");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-focal-length ._up").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-focal-length", "up");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-focal-length ._down").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-focal-length", "down");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-aperture-range ._up").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-aperture-range", "up");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-aperture-range ._down").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-aperture-range", "down");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-iris ._up").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-iris", "up");
								}
							);
							$(".js-biz-products-tbl-sort-ipcctv-iris ._down").on(
								"click",
								function () {
									sortToggle(data, _groupcategory + "-iris", "down");
								}
							);
						} else {
							$("#" + _category)
								.find(".mod-tblWrap")
								.addClass("di_none");
						}
						count++;
						if (count == $(".js-biz-category-ipcctv_others_and_fa").length) {
							if (location.hash) {
								$("html, body").css("opacity", "0");
								setTimeout(function () {
									$("html, body").css("opacity", "1");
									var _hash = "#" + location.hash.split("#")[1];
									var pos = $(_hash).offset().top;
									if ($(window).width() < 768) {
										pos -= 0;
									} else {
										pos -= 0;
									}
									$("html, body")
										.stop()
										.animate({ scrollTop: pos }, 1200, "easeOutExpo");
								}, 100);
							}
						}
					});
				}
			}
		};
		const bizProductsCategoryLwir = () => {
			if ($(".js-biz-category-lwir").length) {
				let count = 0;
				const getJSONProductsCategoryLwir = (_category) => {
					return $.getJSON(
						`/ajax/${lang}/biz/products/detail/s/${_category}.json`
					);
				};
				for (let i = 0; i < $(".js-biz-category-lwir").length; i++) {
					const _category = $(".js-biz-category-lwir")
						.eq(i)
						.find(".rt_cf_pc_code")
						.text();
					getJSONProductsCategoryLwir(_category).done((data) => {
						if (data.rt_bn_products_list.length > 0) {
							const area = $(".js-biz-category-lwir")
								.eq(i)
								.find(".mod-tblWrap table tbody");
							data.rt_bn_products_list.forEach((elem) => {
								addHTML(elem, area, "lwir");
							});
							const sortToggle = function (data, tagCode, type) {
								data.rt_bn_products_list.sort(function (a, b) {
									const getValue = function (item) {
										const found = item.cf_p_tags.find(
											(tag) => tag.cf_pt_group_code == tagCode
										);
										return found
											? found.cf_pt_order
											: "";
									};
									const aValue = getValue(a);
									const bValue = getValue(b);
									if (aValue < bValue) return type == "up" ? -1 : 1;
									if (aValue > bValue) return type == "up" ? 1 : -1;
									return 0;
								});
								area.empty();
								data.rt_bn_products_list.forEach((elem) => {
									addHTML(elem, area, "lwir");
								});
							};
							$(
								"#" + _category + " .js-biz-products-tbl-sort-ccm-sensor ._up"
							).on("click", function () {
								sortToggle(data, "ccm-sensor", "up");
							});
							$(
								"#" + _category + " .js-biz-products-tbl-sort-ccm-sensor ._down"
							).on("click", function () {
								sortToggle(data, "ccm-sensor", "down");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-focal-length ._up"
							).on("click", function () {
								sortToggle(data, "ccm-focal-length", "up");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-focal-length ._down"
							).on("click", function () {
								sortToggle(data, "ccm-focal-length", "down");
							});

							$(
								"#" + _category + " .js-biz-products-tbl-sort-ccm-f-no ._up"
							).on("click", function () {
								sortToggle(data, "ccm-f-no", "up");
							});
							$(
								"#" + _category + " .js-biz-products-tbl-sort-ccm-f-no ._down"
							).on("click", function () {
								sortToggle(data, "ccm-f-no", "down");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-horizonal-field-of-view ._up"
							).on("click", function () {
								sortToggle(data, "ccm-horizonal-field-of-view", "up");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-horizonal-field-of-view ._down"
							).on("click", function () {
								sortToggle(data, "ccm-horizonal-field-of-view", "down");
							});
						} else {
							$("#" + _category)
								.find(".mod-tblWrap")
								.addClass("di_none");
						}
						count++;
						if (count == $(".js-biz-category-lwir").length) {
							if (location.hash) {
								$("html, body").css("opacity", "0");
								setTimeout(function () {
									$("html, body").css("opacity", "1");
									var _hash = "#" + location.hash.split("#")[1];
									var pos = $(_hash).offset().top;
									if ($(window).width() < 768) {
										pos -= 0;
									} else {
										pos -= 0;
									}
									$("html, body")
										.stop()
										.animate({ scrollTop: pos }, 1200, "easeOutExpo");
								}, 100);
							}
						}
					});
				}
			}
		};
		const bizProductsCategoryCompactCameraModule = () => {
			if ($(".js-biz-category-compact-camera-module").length) {
				let count = 0;
				const getJSONProductsCategoryLwir = (_category) => {
					return $.getJSON(
						`/ajax/${lang}/biz/products/detail/s/${_category}.json`
					);
				};
				for (
					let i = 0;
					i < $(".js-biz-category-compact-camera-module").length;
					i++
				) {
					const _category = $(".js-biz-category-compact-camera-module")
						.eq(i)
						.find(".rt_cf_pc_code")
						.text();
					getJSONProductsCategoryLwir(_category).done((data) => {
						if (data.rt_bn_products_list.length > 0) {
							const area = $(".js-biz-category-compact-camera-module")
								.eq(i)
								.find(".mod-tblWrap table tbody");
							data.rt_bn_products_list.forEach((elem) => {
								addHTML(elem, area, "compact-camera-module");
							});
							const sortToggle = function (data, tagCode, type) {
								data.rt_bn_products_list.sort(function (a, b) {
									const getValue = function (item) {
										const found = item.cf_p_tags.find(
											(tag) => tag.cf_pt_group_code == tagCode
										);
										return found
											? found.cf_pt_order
											: "";
									};
									const aValue = getValue(a);
									const bValue = getValue(b);
									if (aValue < bValue) return type == "up" ? -1 : 1;
									if (aValue > bValue) return type == "up" ? 1 : -1;
									return 0;
								});
								area.empty();
								data.rt_bn_products_list.forEach((elem) => {
									addHTML(elem, area, "compact-camera-module");
								});
							};
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-output-pixels ._up"
							).on("click", function () {
								sortToggle(data, "ccm-output-pixels", "up");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-output-pixels ._down"
							).on("click", function () {
								sortToggle(data, "ccm-output-pixels", "down");
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-horizonal-field-of-view_wide-tele ._down"
							).on("click", function () {
								sortToggle(
									data,
									"ccm-horizonal-field-of-view_wide-tele",
									"down"
								);
							});
							$(
								"#" +
									_category +
									" .js-biz-products-tbl-sort-ccm-horizonal-field-of-view_wide-tele ._down"
							).on("click", function () {
								sortToggle(
									data,
									"ccm-horizonal-field-of-view_wide-tele",
									"down"
								);
							});
						} else {
							$("#" + _category)
								.find(".mod-tblWrap")
								.addClass("di_none");
						}
						count++;
						if (count == $(".js-biz-category-compact-camera-module").length) {
							if (location.hash) {
								$("html, body").css("opacity", "0");
								setTimeout(function () {
									$("html, body").css("opacity", "1");
									var _hash = "#" + location.hash.split("#")[1];
									var pos = $(_hash).offset().top;
									if ($(window).width() < 768) {
										pos -= 0;
									} else {
										pos -= 0;
									}
									$("html, body")
										.stop()
										.animate({ scrollTop: pos }, 1200, "easeOutExpo");
								}, 100);
							}
						}
					});
				}
			}
		};
		const bizProductsCategoryVarifocal = () => {
			if ($(".js-biz-category-varifocal").length) {
				let count = 0;
				const getJSONProductsCategoryVarifocal = (_category, _tag) => {
					return $.getJSON(
						`/ajax/${lang}/biz/products/detail/st/${_category}/${_tag}.json`
					);
				};
				for (let i = 0; i < $(".js-biz-category-varifocal").length; i++) {
					$(".js-biz-category-varifocal")
						.eq(i)
						.find(".js-biz-category-varifocal-tag")
						.each((idx, val) => {
							const _category1 = $(".js-biz-category-varifocal")
								.eq(i)
								.find(".rt_cf_pc_code")
								.text();
							const _category2 = $(val).find(".rt_cf_pt_url").text();
							getJSONProductsCategoryVarifocal(_category1, _category2).done(
								(data) => {
									const area = $(val).find(".mod-tblWrap table tbody");

									if (data.rt_bn_products_list.length > 0) {
										data.rt_bn_products_list.forEach((elem) => {
											addHTML(elem, area, "other");
										});
										const sortToggle = function (data, tagCode, type) {
											data.rt_bn_products_list.sort(function (a, b) {
												const getValue = function (item) {
													const found = item.cf_p_tags.find(
														(tag) => tag.cf_pt_group_code == tagCode
													);
													return found
														? found.cf_pt_order
														: "";
												};
												const aValue = getValue(a);
												const bValue = getValue(b);
												if (aValue < bValue) return type == "up" ? -1 : 1;
												if (aValue > bValue) return type == "up" ? 1 : -1;
												return 0;
											});
											area.empty();
											data.rt_bn_products_list.forEach((elem) => {
												addHTML(elem, area, "other");
											});
										};
										$(val)
											.find(".js-biz-products-tbl-sort-ipcctv-imager-size ._up")
											.on("click", function () {
												sortToggle(data, "ipcctv-imager-size", "up");
											});
										$(val)
											.find(
												".js-biz-products-tbl-sort-ipcctv-imager-size ._down"
											)
											.on("click", function () {
												sortToggle(data, "ipcctv-imager-size", "down");
											});

										$(val)
											.find(
												".js-biz-products-tbl-sort-ipcctv-focal-length ._up"
											)
											.on("click", function () {
												sortToggle(data, "ipcctv-focal-length", "up");
											});
										$(val)
											.find(
												".js-biz-products-tbl-sort-ipcctv-focal-length ._down"
											)
											.on("click", function () {
												sortToggle(data, "ipcctv-focal-length", "down");
											});
										$(val)
											.find(
												".js-biz-products-tbl-sort-ipcctv-aperture-range ._up"
											)
											.on("click", function () {
												sortToggle(data, "ipcctv-aperture-range", "up");
											});
										$(val)
											.find(
												".js-biz-products-tbl-sort-ipcctv-aperture-range ._down"
											)
											.on("click", function () {
												sortToggle(data, "ipcctv-aperture-range", "down");
											});
										$(val)
											.find(".js-biz-products-tbl-sort-ipcctv-iris ._up")
											.on("click", function () {
												sortToggle(data, "ipcctv-iris", "up");
											});
										$(val)
											.find(".js-biz-products-tbl-sort-ipcctv-iris ._down")
											.on("click", function () {
												sortToggle(data, "ipcctv-iris", "down");
											});
									} else {
										$(val).find(".mod-tblWrap").addClass("di_none");
									}
									count++;
									if (count == $(".js-biz-category-varifocal-tag").length) {
										if (location.hash) {
											$("html, body").css("opacity", "0");
											setTimeout(function () {
												$("html, body").css("opacity", "1");
												var _hash = "#" + location.hash.split("#")[1];
												var pos = $(_hash).offset().top;
												if ($(window).width() < 768) {
													pos -= 0;
												} else {
													pos -= 0;
												}
												$("html, body")
													.stop()
													.animate({ scrollTop: pos }, 1200, "easeOutExpo");
											}, 100);
										}
									}
								}
							);
						});
				}
			}
		};
		bizProductsCategoryIpcctvOthersAndFa();
		bizProductsCategoryLwir();
		bizProductsCategoryCompactCameraModule();
		bizProductsCategoryVarifocal();
	};
	const bizProductsDetail = () => {
		if ($(".js-biz-products-detail-products-tbl-imager").length) {
			$(".js-biz-products-detail-products-tbl-imager").each((idx, val) => {
				if (!$(val).text().replace(/(^\s+)|(\s+$)/g, "").length) {
					$(val).remove();
				}
			});
			$(".js-biz-products-detail-products-tbl-imager").each((idx, val) => {
				if(!(idx == ($(".js-biz-products-detail-products-tbl-imager").length - 1))) {
					$(val).append(',');
				}
			});
		}
	};
	slider();
	bizSearch();
	bizDownload();
	moreItem();
	bizProductsCategory1();
	bizProductsCategory2();
	bizProductsDetail();
})(window.jQuery, window.FUNCTIONS);
